"use strict";

var _objectSpread = require("/var/www/ivy-temp/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/helpers/objectSpread2.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MAP_ACTION_DESCRIPTIONS = exports.MAP_ACTION_ICON_CATALOG = exports.DEFAULT_MAP_ACTIONS = exports.MAX_MAP_ACTION_ICON_BYTES = exports.MAX_MAP_ACTION_ICON_URL_LENGTH = exports.MAX_MAP_ACTION_DISABLED_MESSAGE_LENGTH = exports.MAX_MAP_ACTION_BADGE_TEXT_LENGTH = exports.MAX_MAP_ACTION_LABEL_LENGTH = exports.MapActionState = exports.MapActionKey = void 0;
exports.isMapActionCatalogIcon = isMapActionCatalogIcon;
exports.buildDefaultMapActions = buildDefaultMapActions;
exports.parseMapActions = parseMapActions;
exports.validateMapActionsForSave = validateMapActionsForSave;
exports.validateMapActionIconSvg = validateMapActionIconSvg;
/**
 * New-UI map filters: the vertical action sidebar on the mobile map
 * (`MapActionSidebar`). Picking one narrows/recolors the venue markers and
 * shows a pill at the bottom of the map. Admin-configurable (Feature Flags ->
 * Map filters), exposed on `/me` as `mapActions` and live over the socket as
 * `featureFlagUpdated` (key `mapActions`).
 */
var MapActionKey;
(function (MapActionKey) {
  /** Today's Plans — visit plan count. */
  MapActionKey["Tickets"] = "tickets";
  /** Popular today — check-ins today. */
  MapActionKey["Trending"] = "trending";
  /** Active stickers. Also gated by the `stickers` kill switch. */
  MapActionKey["Stickers"] = "stickers";
  /** My Places — pinned venues only, heart badge. */
  MapActionKey["Favorite"] = "favorite";
  /** Check-ins. */
  MapActionKey["Friends"] = "friends";
  /** Footprints — venues visited in the last 30 days, clock badge. */
  MapActionKey["History"] = "history";
})(MapActionKey || (exports.MapActionKey = MapActionKey = {}));
var MapActionState;
(function (MapActionState) {
  /** Shown and selectable. */
  MapActionState["Active"] = "active";
  /** Shown dimmed; tapping shows [MapActionConfigItem.disabledMessage] instead of selecting it. */
  MapActionState["Disabled"] = "disabled";
  /** Not shown in the sidebar at all. */
  MapActionState["Hidden"] = "hidden";
})(MapActionState || (exports.MapActionState = MapActionState = {}));
exports.MAX_MAP_ACTION_LABEL_LENGTH = 30;
exports.MAX_MAP_ACTION_BADGE_TEXT_LENGTH = 40;
exports.MAX_MAP_ACTION_DISABLED_MESSAGE_LENGTH = 120;
exports.MAX_MAP_ACTION_ICON_URL_LENGTH = 1024;
/** Upload limit for a custom icon. */
exports.MAX_MAP_ACTION_ICON_BYTES = 32 * 1024;
const HEX_COLOR = /^#[0-9a-fA-F]{6}$/;
exports.DEFAULT_MAP_ACTIONS = [{
  key: MapActionKey.Tickets,
  label: 'Events',
  badgeText: "Today's Plans",
  color: '#045EF9',
  iconName: null,
  iconUrl: null,
  state: MapActionState.Active,
  disabledMessage: ''
}, {
  key: MapActionKey.Trending,
  label: 'Trending',
  badgeText: 'Popular Today',
  color: '#FF5900',
  iconName: null,
  iconUrl: null,
  state: MapActionState.Active,
  disabledMessage: ''
}, {
  key: MapActionKey.Stickers,
  label: 'Stickers',
  badgeText: 'Stickers Activity',
  color: '#9747FF',
  iconName: null,
  iconUrl: null,
  state: MapActionState.Active,
  disabledMessage: ''
}, {
  key: MapActionKey.Favorite,
  label: 'Favorite',
  badgeText: 'My Places List',
  color: '#FE364D',
  iconName: null,
  iconUrl: null,
  state: MapActionState.Active,
  disabledMessage: ''
}, {
  key: MapActionKey.Friends,
  label: 'Checkins',
  badgeText: 'Checkins',
  color: '#E53935',
  iconName: null,
  iconUrl: null,
  state: MapActionState.Active,
  disabledMessage: ''
}, {
  key: MapActionKey.History,
  label: 'Footprints',
  badgeText: 'Footprint List',
  color: '#00A3BA',
  iconName: null,
  iconUrl: null,
  state: MapActionState.Active,
  disabledMessage: ''
}];
/**
 * Icons an admin can pick by name — Heroicons v2 outline (MIT, the set the
 * built-in icons come from), bundled as identical SVGs in the admin
 * (`public/images/map-actions/catalog/<name>.svg`) and the app
 * (`assets/icons/map_icon_<name with _>.svg`). Adding one needs both files.
 */
exports.MAP_ACTION_ICON_CATALOG = [{
  name: 'ticket',
  label: 'Ticket'
}, {
  name: 'calendar-days',
  label: 'Calendar'
}, {
  name: 'arrow-trending-up',
  label: 'Trending'
}, {
  name: 'fire',
  label: 'Fire'
}, {
  name: 'bolt',
  label: 'Bolt'
}, {
  name: 'sparkles',
  label: 'Sparkles'
}, {
  name: 'heart',
  label: 'Heart'
}, {
  name: 'star',
  label: 'Star'
}, {
  name: 'bookmark',
  label: 'Bookmark'
}, {
  name: 'users',
  label: 'Users'
}, {
  name: 'user-group',
  label: 'Group'
}, {
  name: 'face-smile',
  label: 'Smile'
}, {
  name: 'clock',
  label: 'Clock'
}, {
  name: 'map-pin',
  label: 'Map pin'
}, {
  name: 'musical-note',
  label: 'Music'
}, {
  name: 'trophy',
  label: 'Trophy'
}];
function isMapActionCatalogIcon(name) {
  return typeof name === 'string' && exports.MAP_ACTION_ICON_CATALOG.some(icon => icon.name === name);
}
/** What each filter does — shown in the admin editor. */
exports.MAP_ACTION_DESCRIPTIONS = {
  [MapActionKey.Tickets]: "Shows only venues with visit plans for today; badge = today's visit plan count.",
  [MapActionKey.Trending]: 'Shows only venues with check-ins today; badge = check-ins today.',
  [MapActionKey.Stickers]: 'Shows only venues with active stickers; badge = sticker count. Also needs the Stickers switch on.',
  [MapActionKey.Favorite]: "Shows only the user's My Places with a heart badge; the pill opens the My Places list.",
  [MapActionKey.Friends]: 'Shows only venues with check-ins; badge = total check-ins.',
  [MapActionKey.History]: 'Shows only venues the user visited in the last 30 days with a clock badge; the pill opens Footprints. ' + 'Still disabled for a user who turned Footprints off.'
};
function buildDefaultMapActions() {
  return exports.DEFAULT_MAP_ACTIONS.map(entry => _objectSpread({}, entry));
}
function trimmedString(value, maxLength) {
  if (typeof value !== 'string') return null;
  const trimmed = value.trim();
  return trimmed.length > 0 && trimmed.length <= maxLength ? trimmed : null;
}
function parseIconUrl(value) {
  const url = trimmedString(value, exports.MAX_MAP_ACTION_ICON_URL_LENGTH);
  return url && url.startsWith('https://') ? url : null;
}
/** Exactly one entry per [MapActionKey], in the saved order — unknown/duplicate
 * keys are dropped, invalid fields fall back to the default, missing keys are
 * appended in default order. */
function parseMapActions(raw) {
  const defaults = buildDefaultMapActions();
  if (!Array.isArray(raw)) {
    return defaults;
  }
  const keys = Object.values(MapActionKey);
  const result = [];
  const seen = new Set();
  for (const entry of raw) {
    var _trimmedString, _trimmedString2, _trimmedString3;
    if (!entry || typeof entry !== 'object') continue;
    const value = entry;
    const key = value.key;
    if (typeof key !== 'string' || !keys.includes(key) || seen.has(key)) continue;
    seen.add(key);
    const fallback = defaults.find(d => d.key === key);
    const color = typeof value.color === 'string' && HEX_COLOR.test(value.color.trim()) ? value.color.trim() : null;
    const state = Object.values(MapActionState).includes(value.state) ? value.state : fallback.state;
    result.push({
      key: key,
      label: (_trimmedString = trimmedString(value.label, exports.MAX_MAP_ACTION_LABEL_LENGTH)) !== null && _trimmedString !== void 0 ? _trimmedString : fallback.label,
      badgeText: (_trimmedString2 = trimmedString(value.badgeText, exports.MAX_MAP_ACTION_BADGE_TEXT_LENGTH)) !== null && _trimmedString2 !== void 0 ? _trimmedString2 : fallback.badgeText,
      color: (color !== null && color !== void 0 ? color : fallback.color).toUpperCase(),
      iconName: isMapActionCatalogIcon(value.iconName) ? value.iconName : null,
      iconUrl: parseIconUrl(value.iconUrl),
      state,
      disabledMessage: (_trimmedString3 = trimmedString(value.disabledMessage, exports.MAX_MAP_ACTION_DISABLED_MESSAGE_LENGTH)) !== null && _trimmedString3 !== void 0 ? _trimmedString3 : ''
    });
  }
  for (const fallback of defaults) {
    if (!seen.has(fallback.key)) result.push(fallback);
  }
  return result;
}
function validateMapActionsForSave(value) {
  if (!Array.isArray(value)) {
    return {
      message: 'mapActions must be an array.'
    };
  }
  const keys = Object.values(MapActionKey);
  if (value.length !== keys.length) {
    return {
      message: "mapActions must include exactly ".concat(keys.length, " entries.")
    };
  }
  const seen = new Set();
  for (let i = 0; i < value.length; i++) {
    const entry = value[i];
    if (!entry || typeof entry !== 'object') {
      return {
        message: "mapActions[".concat(i, "] must be an object.")
      };
    }
    const {
      key,
      label,
      badgeText,
      color,
      iconName,
      iconUrl,
      state,
      disabledMessage
    } = entry;
    if (typeof key !== 'string' || !keys.includes(key)) {
      return {
        message: "mapActions[".concat(i, "].key must be a valid MapActionKey.")
      };
    }
    if (seen.has(key)) {
      return {
        message: "Duplicate mapActions key \"".concat(key, "\".")
      };
    }
    seen.add(key);
    if (trimmedString(label, exports.MAX_MAP_ACTION_LABEL_LENGTH) == null) {
      return {
        message: "".concat(key, ": label must be 1\u2013").concat(exports.MAX_MAP_ACTION_LABEL_LENGTH, " characters.")
      };
    }
    if (trimmedString(badgeText, exports.MAX_MAP_ACTION_BADGE_TEXT_LENGTH) == null) {
      return {
        message: "".concat(key, ": badge text must be 1\u2013").concat(exports.MAX_MAP_ACTION_BADGE_TEXT_LENGTH, " characters.")
      };
    }
    if (typeof color !== 'string' || !HEX_COLOR.test(color.trim())) {
      return {
        message: "".concat(key, ": color must be a #RRGGBB hex value.")
      };
    }
    if (iconName != null && !isMapActionCatalogIcon(iconName)) {
      return {
        message: "".concat(key, ": \"").concat(String(iconName), "\" is not in the icon catalog.")
      };
    }
    if (iconUrl != null && parseIconUrl(iconUrl) == null) {
      return {
        message: "".concat(key, ": iconUrl must be an https URL or null.")
      };
    }
    if (!Object.values(MapActionState).includes(state)) {
      return {
        message: "".concat(key, ": state must be one of ").concat(Object.values(MapActionState).join(', '), ".")
      };
    }
    if (disabledMessage != null && (typeof disabledMessage !== 'string' || disabledMessage.trim().length > exports.MAX_MAP_ACTION_DISABLED_MESSAGE_LENGTH)) {
      return {
        message: "".concat(key, ": disabled message must be at most ").concat(exports.MAX_MAP_ACTION_DISABLED_MESSAGE_LENGTH, " characters.")
      };
    }
  }
  return null;
}
/** Rejects SVGs that could run script when opened directly; the app only needs plain vector paths. */
function validateMapActionIconSvg(svg) {
  if (!/<svg[\s>]/i.test(svg)) {
    return {
      message: 'The icon must be an SVG file.'
    };
  }
  if (/<script|<foreignObject|\son\w+\s*=|javascript:|<!ENTITY/i.test(svg)) {
    return {
      message: 'The SVG contains scripts or event handlers, which are not allowed.'
    };
  }
  return null;
}
//# sourceMappingURL=map-actions-config.js.map